export const inspections = {
shared: {
  jobVisibility: {
    contractors: "Contratistas",
    team: "Equipo",
    private: "Privada",
  },
  jobCategory: {
    Other: "Otro",
    Cleaning: "Limpieza",
    Installation: "Instalación",
    Replacement: "Sustitución",
    Inspection: "Inspección",
    Maintenance: "Mantenimiento",
    Repair: "Reparación",
  },
checklistCategory: {
Inspection: "Inspección",
Check: "Comprobación",
Audit: "Auditoría",
SafetyReview: "Revisión de seguridad",
Maintenance: "Mantenimiento",
General: "General",
},
itemsAnswered_one: "{{value}} de {{count}} elemento respondido ({{percent}}%)",
itemsAnswered_many: "{{value}} de {{count}} de elementos respondidos ({{percent}}%)",
itemsAnswered_other: "{{value}} de {{count}} elementos respondidos ({{percent}}%)",
workflowRationale: {
explicit: "Elegido para esta inspección.",
lastUsed: "Usado por última vez para este activo.",
bestMatch: "El flujo de trabajo más compatible con este tipo de activo.",
history: "Según las últimas {{inspections}} de este activo ({{every}}).",
historyInspections_one: "{{count}} inspección",
historyInspections_many: "{{count}} de inspecciones",
historyInspections_other: "{{count}} inspecciones",
historyEvery_one: "aproximadamente a diario",
historyEvery_many: "aproximadamente cada {{count}} de días",
historyEvery_other: "aproximadamente cada {{count}} días",
assetTypeDefault: {
car: "Frecuencia inicial habitual para vehículos: ajústela según sea necesario.",
property: "Frecuencia inicial habitual para propiedades: ajústela según sea necesario.",
equipment: "Frecuencia inicial habitual para equipos: ajústela según sea necesario.",
other: "Frecuencia inicial habitual para otros activos: ajústela según sea necesario.",
},
},
executionMode: {
list: "Lista",
guidedGroup: "Guiado por grupo",
guidedItem: "Guiado por elemento",
},
recordStatus: {
inProgress: "En curso",
paused: "En pausa",
submitted: "Enviada",
approved: "Conforme",
completed: "Completada",
cancelled: "Cancelada",
},
},
start: {
  planningLoadErrorTitle: "No se pudo abrir la planificación",
  planningAssetUnavailable: "Este activo no está disponible o ya no tienes acceso.",
  planningAssetMismatch: "Esta solicitud es de otro activo. Abre la solicitud e inténtalo de nuevo.",
  planningLoading: "Preparando todo…",
  planningTitle: "Planificar el trabajo",
setupRequiredTitle: "Configuración necesaria",
setupRequiredBodyAll: "Añade al menos un activo y una lista de verificación antes de iniciar una inspección.",
setupRequiredBodyAssets: "Añade al menos un activo antes de iniciar una inspección.",
setupRequiredBodyTemplates: "Crea al menos una lista de verificación antes de iniciar una inspección.",
addAsset: "Añadir activo",
createChecklist: "Crear lista de verificación",
createChecklistA11y: "Crear lista de verificación",
createChecklistSheetTitle: "Crear lista de verificación",
createChecklistSheetSubtitle: "Elige cómo quieres crear tu lista de verificación.",
createChecklistWithAi: "Generar con IA",
createChecklistManually: "Crear manualmente",
overlayReturnFootnote: "Se abre en una superposición. Al guardar, vuelves aquí para iniciar o programar.",
stepSelectAsset: "1. Selecciona el activo",
searchAssetsPlaceholder: "Buscar activos",
searchAssetsA11y: "Buscar activos",
allTypesA11y: "Mostrar todos los tipos de activo",
tapSelectedAssetToChange: "Toca el activo seleccionado para cambiarlo.",
noAssetsMatch: "Ningún activo coincide con tu búsqueda.",
stepSelectChecklist: "2. Selecciona la lista de verificación",
noChecklistsForAssetType: "Ninguna lista de verificación coincide con el tipo de activo {{assetType}}.",
selectAssetFirst: "Selecciona primero un activo para mostrar las listas de verificación compatibles.",
searchChecklistsPlaceholder: "Buscar listas de verificación",
searchChecklistsA11y: "Buscar listas de verificación",
showingChecklistsFor: "Mostrando listas de verificación para {{assetType}}",
tapSelectedChecklistToChange: "Toca la lista de verificación seleccionada para cambiarla.",
noChecklistsMatch: "Ninguna lista de verificación coincide con tu búsqueda.",
stepAssignInspector: "3. Asigna e inicia",
youSuffix: " (Tú)",
you: "Tú",
onlyTeamMember: "Solo tu miembro de equipo está disponible ahora mismo.",
createTeamToAssign: "Crea un equipo para asignar inspecciones a otras personas.",
executionModeLabel: "Modo de ejecución",
locationTitle: "Ubicación actual",
locationLoading: "Comprobando tu ubicación...",
locationNotSupported: "La ubicación no es compatible con este dispositivo.",
locationPermissionDenied: "Se denegó el permiso de ubicación.",
locationUnavailableFallback: "La ubicación no está disponible.",
locationUnavailableMessage: "Ubicación no disponible: {{reason}}",
starting: "Iniciando...",
startInspection: "Iniciar inspección",
prefilledMomentumHint: "Revisa las opciones de abajo y toca Iniciar inspección.",
scheduleForLater: "Programar para más tarde",
noPriority: "Sin prioridad",
requestContextEyebrow: "Inspección para la solicitud",
requesterNotSet: "No definido",
requestHandoff: {
requesterFallback: "el solicitante",
decisionStartNow: "Decisión: iniciar ahora",
},
alerts: {
selectAsset: "Selecciona un activo antes de continuar.",
selectChecklist: "Selecciona una lista de verificación antes de continuar.",
selectAssetAndChecklist: "Selecciona un activo y una lista de verificación para iniciar.",
assetArchivedTitle: "Activo archivado",
assetArchivedBody: "Los activos archivados no se pueden inspeccionar. Elige otro activo.",
assetArchivedScheduleBody: "Los activos archivados no se pueden programar para inspección. Elige otro activo.",
couldNotStartTitle: "No se pudo iniciar la inspección",
couldNotStartBody: "Inténtalo de nuevo.",
},
},
share: {
title: "Compartir informe",
},
report: {
coverEyebrow: "Informe de estado",
coverUntitled: "Activo sin título",
sectionSubject: "Asunto",
statInspected: "Inspeccionado",
statRepairs: "Reparaciones",
statEstTotal: "Total estimado",
},
sentForApproval: {
subtitle: "Enviaremos un enlace de revisión por correo. Te avisaremos cuando respondan.",
backToHome: "Volver al inicio",
viewReport: "Ver informe",
},
detail: {
  sendBack: {
    errors: {
      notAllowed: "Solo quien aprueba el trabajo de este activo puede devolverla.",
      notWaiting: "Esta inspección ya no espera aprobación. Puede que alguien acabe de aprobarla o devolverla.",
      ownWork: "No puedes devolver una inspección que hiciste tú.",
      reasonRequired: "Escribe entre 3 y 1000 caracteres para que sepa qué corregir.",
    },
    noticeHint: "Corrige lo que te pidieron y vuelve a tocar «Completar inspección». Volverá a esa persona para que la apruebe.",
    noticeReason: "«{{reason}}»",
    noticeTitle: "{{name}} devolvió esta inspección",
    approverFallback: "La persona que aprueba",
    inspectorFallback: "el inspector",
    failedTitle: "No se pudo devolver",
    sent: "Devuelta a {{name}}. Verá tu motivo.",
    sending: "Devolviendo…",
    confirm: "Devolver",
    reasonTooShort: "Escribe unas palabras para que sepa qué corregir.",
    reasonPlaceholder: "Por ejemplo: añade una foto del desagüe del tejado.",
    reasonLabel: "Qué hay que corregir",
    hint: "Di qué hay que corregir. {{name}} recibe una notificación y la inspección se vuelve a abrir para esa persona.",
    title: "Devolver a {{name}}",
    buttonA11y: "Devolver esta inspección a {{name}} con un motivo",
    button: "Devolver",
  },
  errors: {
    completeTitle: "No se pudo completar la inspección",
    deleteTitle: "No se pudo eliminar la inspección",
    continueTitle: "No se pudo continuar la inspección",
    takeOverTitle: "No se pudo hacer en su lugar",
    reopenTitle: "No se pudo reabrir la inspección",
    approveTitle: "No se pudo aprobar la inspección",
    suggestionTitle: "No se pudo añadir esa sugerencia",
    reloadTitle: "No se pudo cargar su versión",
    mergeTitle: "No se pudieron conservar tus respuestas",
    checkConnection: "Comprueba tu conexión e inténtalo de nuevo.",
  },
  outline: {
    title: "Puntos · {{done}} de {{total}} respondidos",
    jumpA11y: "Ir al punto {{n}}, {{label}}, {{state}}",
    state: { failed: "no superado", done: "respondido", skipped: "omitido", pending: "pendiente" },
  },
findingsNextActionsTitle: "Hallazgos y próximas acciones",
assetContext: {
asset: "Activo",
previousOnThisAsset: "Anterior sobre este activo",
manuals: "Manuales",
noAssetLinked: "Sin activo vinculado",
openAsset: "Abrir activo →",
openAssetA11y: "Abrir activo",
},
approval: {
  fixAndResend: "Corregir y reenviar",
  fixHint: "Corrige lo que te pidieron y vuelve a enviar el informe.",
  changesAskedNoReason: "{{name}} pidió cambios.",
  changesAsked: "{{name}} pidió cambios: «{{reason}}»",
  linkCopied: "Enlace copiado. Pégalo en un mensaje para {{name}}.",
  sendAgainA11y: "Enviar de nuevo el informe a {{name}}",
  sendAgain: "Enviar de nuevo",
  sentToDue: "Enviado a {{name}} el {{date}} · respuesta antes del {{due}}",
  sentTo: "Enviado a {{name}} el {{date}}",
  summary: {
    nextNotShared: "Completa la inspección y comparte el informe si alguien debe aprobarlo.",
    nextWaitingFor: "Esperando a que {{name}} dé conformidad a esta inspección.",
    nextWaitingForTeam: "Esperando a que alguien de {{name}} dé conformidad a esta inspección.",
    nextStepWaited_many: "{{nextStep}} Esperando desde hace {{count}} días.",
    nextStepWaited_one: "{{nextStep}} Esperando desde hace {{count}} día.",
    nextStepWaited_other: "{{nextStep}} Esperando desde hace {{count}} días.",
    nextYouApprove: "Revisa los hallazgos y toca Dar conformidad.",
    nextWaitingShared: "Esperando la respuesta de la persona con quien lo compartiste.",
    nextResponded: "Lee la respuesta y decide qué hacer.",
    nextRespondedJobs: "Las reparaciones aprobadas están listas para convertirse en órdenes de trabajo.",
    nextChangesRequested: "Lee los comentarios, actualiza la inspección y vuelve a compartirla.",
    nextApproved: "Conforme. Abre Próximos pasos o comparte el informe.",
    nextApprovedJobs: "Revisa las reparaciones aprobadas y crea las órdenes de trabajo.",
    noApproverYet: "Aún sin aprobador",
    recipientFallback: "Destinatario",
    statusNotShared: "Sin compartir",
    statusAwaiting: "Pendiente de conformidad",
    statusResponded: "Respondida",
    statusChangesRequested: "Cambios solicitados",
    statusApproved: "Conforme",
  },
  askAiDraft: "Ayúdame a revisar la inspección {{checklist}} de {{asset}} del {{date}} y a decidir el siguiente paso.",
  closeIt: "Cerrar",
  keepWaiting: "Seguir esperando",
  closeConfirmBody: "{{name}} no ha respondido. Las reparaciones propuestas se registrarán como no aprobadas en su nombre.",
  closeConfirmTitle: "¿Cerrar sin respuesta?",
  takeOverSignedOff: "Aprobado en lugar de {{name}}",
  takeOverClosed: "Cerrado sin respuesta",
  takeOverApproved: "Aprobado en nombre de {{name}}",
  teamApprover: "Cualquier miembro de {{name}}",
  assetApprover: "Aprobador del activo",
  approverFallback: "el aprobador",
  reopenConfirm: "Reabrir",
  reopenConfirmBody: "Podrás cambiar las respuestas y después completar la inspección otra vez.",
  reopenConfirmApproved: "{{name}} la aprobó. Al reabrirla se borra esa aprobación y habrá que aprobarla otra vez.",
  reopenConfirmTitle: "¿Reabrir esta inspección?",
approval: "Aprobación",
statusSummaryA11y: "Estado de aprobación: {{status}}. {{action}}",
collapse: "Contraer",
showDetails: "Mostrar detalles",
currentStatus: "Estado actual",
approver: "Aprobador",
nextStep: "Siguiente paso",
approveInspectionA11y: "Dar conformidad a esta inspección",
approving: "Dando conformidad…",
approveInspection: "Dar conformidad",
openNextStepsA11y: "Abrir próximos pasos",
nextSteps: "Próximos pasos",
shareReportA11y: "Comparte el informe",
shareReport: "Compartir informe",
reopenAndClearA11y: "Reabrir esta inspección y borrar su aprobación.",
reopenA11y: "Reabrir esta inspección",
reopening: "Reapertura…",
reopenAndClear: "Reabrir y borrar la aprobación",
reopenInspection: "Reabrir la inspección",
},
lifecycle: {
pauseTitle: "Pausar inspección",
pauseHint: "Añade opcionalmente un motivo y programa cuándo reanudar.",
reasonOptional: "Motivo (opcional)",
pauseReasonPlaceholder: "por ej. Esperando piezas, necesito la aprobación del cliente.",
resumeDateOptional: "Fecha de reanudación (opcional)",
selectDate: "Seleccionar fecha",
resumeTimeOptional: "Hora de reanudación (opcional)",
selectTime24h: "Seleccionar hora (24h)",
cancel: "Cancelar",
pause: "Pausar",
cancelTitle: "Cancelar inspección",
cancelHint: "El progreso se guarda pero la inspección se marcará como cancelada. Por favor proporcione una razón.",
cancellationReason: "Motivo de cancelación",
cancelReasonPlaceholder: "por ej. Activo vendido, inspección duplicada, lista de verificación incorrecta",
back: "Mantener la inspección",
cancelInspection: "Cancelar inspección",
reassignTitle: "Reasignar inspección",
reassigned: "Reasignada a {{name}}. La inspección sigue en curso para esa persona.",
reassignFailed: "No se pudo reasignar la inspección. Inténtelo de nuevo.",
pickContractorTitle: "Asignarla a un contratista",
contractorNoAccountTitle: "Aún no tiene cuenta de AssetWRX",
contractorNoAccountBody: "{{name}} necesita una cuenta de AssetWRX para realizar una inspección. Invítelo desde Contactos; cuando se una, podrá asignársela.",
cancelReasonRequired: "Indique un motivo de cancelación.",
cancelledTitle: "Cancelada",
cancelledBody: "La inspección se ha cancelado.",
cancelFailed: "No se pudo cancelar la inspección. Inténtelo de nuevo.",
pauseFailed: "No se pudo pausar la inspección. Inténtelo de nuevo.",
errorTitle: "Error",
searchTeamMembersPlaceholder: "Buscar miembros del equipo…",
noTeamMemberMatch: "Ningún miembro del equipo coincide.",
skipTitle: "¿Omitir este elemento?",
skipHint: "Agregue una nota breve si ayuda a su equipo (opcional). Toque Omitir para confirmar.",
noteOptional: "Nota (opcional)",
skipReasonPlaceholder: "por ej. Sin acceso, no aplicable",
skip: "Omitir",
},
repair: {
proposedFollowUp: "¿Necesita una orden de trabajo?",
confirmedAfterCompletion: "(confirmado después de la finalización)",
markForFollowUp: "Sí, crear una orden de trabajo",
titleField: "Título *",
titlePlaceholder: "por ej. Reparar grifo que gotea",
priority: "Prioridad",
priorityFallback: "Media",
description: "Descripción *",
descriptionPlaceholder: "¿Qué hay que hacer...?",
descriptionFallback: "Ninguno",
hideOptionsA11y: "Ocultar opciones de seguimiento",
showOptionsA11y: "Mostrar más opciones de seguimiento",
lessOptions: "Menos opciones",
moreOptions: "Más opciones",
repairCategory: "Categoría de reparación",
repairCategoryFallback: "Reparación",
skillsOptional: "Competencias (opcional)",
skills: "Competencias",
selected: "Seleccionado",
none: "Ninguno",
dueDateOptional: "Fecha de vencimiento (opcional)",
visibility: "Visibilidad",
visibilityFallback: "Privado",
estimatedCostOptional: "Costo estimado (opcional)",
notSet: "Sin definir",
costPlaceholder: "0.00",
requiresUrgentRepair: "Requiere reparación urgente",
urgentRepairNoteLabel: "Nota de reparación urgente",
noNote: "Sin nota",
markFollowUpHintPrefix: "Cuando completes la inspección, confirmarás esta orden de trabajo en ",
markFollowUpHintSuffix: " antes de que se cree.",
},
urgentNote: {
placeholder: "¿Por qué urgente?",
stop: "Detener",
dictate: "Dictar",
cleaningUpEllipsis: "Limpiando...",
aiCleanUp: "Limpiar con IA",
addNoteFirstTitle: "Añade una nota primero.",
addNoteFirstBody: "Escriba una breve nota antes de utilizar la limpieza de IA.",
cleaningUp: "Limpiando la nota urgente",
unableToCleanUpTitle: "No se puede limpiar la nota",
cleanedUpTitle: "Nota urgente limpiada",
reviewSuggestedWording: "Revise la redacción sugerida antes de aplicarla.",
},
followUpModal: {
eyebrow: "Acción de inspección",
title: "¿Necesita una orden de trabajo?",
closeA11y: "Cerrar seguimiento",
saveHint: "Márcala y completa la inspección. Confirmarás la orden de trabajo antes de que se cree.",
doneEditingA11y: "Edición completada del seguimiento propuesto.",
done: "Hecho",
},
imageFindingsOverlay: {
findingA11y: "Hallazgo: {{label}}",
confidenceSeverity: "Confianza: {{confidence}}% · Gravedad: {{severity}}",
removeMarkerA11y: "Eliminar marcador de hallazgo",
removeMarker: "Quitar marcador",
close: "Cerrar",
},
quickRating: {
quickRatingA11y: "Clasificación rápida",
yes: "Sí",
no: "No",
quickLevelA11y: "Nivel rápido",
conditionRatingA11y: "Calificación del estado",
},
imageViewer: {
couldNotLoad: "No se pudo cargar la imagen",
closeA11y: "Cerrar el visor de imágenes",
},
noteSheet: {
eyebrow: "Nota de inspección",
title: "Añadir una nota",
closeA11y: "Cerrar nota",
hint: "Escríbalo o dicte y llegará a la misma nota.",
placeholder: "Agregar notas de inspección...",
dictateStop: "Deja de dictar",
dictateFinishing: "Finalizando…",
dictateUnavailable: "Dictado no disponible",
dictateIdle: "Dictar",
doneA11y: "Hecho",
done: "Hecho",
},
imageAnalysis: {
coverage: {
observed: "Visible",
partial: "Parcialmente visible",
not_observed: "No visible: responde manualmente",
},
analysePhoto: "Analizar foto con IA",
analysePhotoA11y: "Analizar foto con IA",
aiQueued: "Análisis de IA en cola",
photoAnalysisTitle: "Análisis de fotos",
analysing: "Analizando...",
suggestedComment: "Comentario sugerido",
severity: "Gravedad: {{severity}}",
status: "Estado: {{status}}",
findings: "Hallazgos",
appendToComments: "Agregar a los comentarios",
replaceComments: "Reemplazar comentarios",
ignore: "Ignorar",
removeFindingA11y: "Eliminar hallazgo {{label}}",
remove: "Quitar",
replaceConfirmTitle: "¿Reemplazar comentarios?",
replaceConfirmBody: "Esto reemplazará su nota existente con la sugerencia de IA.",
replaceConfirmCancel: "Cancelar",
replaceConfirmReplace: "Reemplazar",
},
runnerHeader: {
doneCount: "{{completed}}/{{total}} completados",
failCount: "{{count}} por revisar",
urgentCountLabel_one: "{{count}} urgente",
urgentCountLabel_many: "{{count}} urgentes",
urgentCountLabel_other: "{{count}} urgentes",
modeLabel: {
list: "Lista",
guidedGroup: "Por grupo",
guidedItem: "Por elemento",
},
modeDesc: {
list: "Ver todos los elementos a la vez",
guidedGroup: "Un grupo a la vez",
guidedItem: "Un elemento a la vez",
},
cancelled: "Cancelado",
paused: "Pausada",
sectionEyebrow: "Sección {{index}} de {{count}}",
openAssetA11y: "Abrir {{assetName}}",
openSyncConflictA11y: "Abrir opciones de conflicto de sincronización",
retrySaveA11y: "Reintentar guardar las respuestas de la inspección",
review: "Revisar",
retry: "Reintentar",
askAiCompactA11y: "Según sus respuestas, la IA puede ayudar en las próximas comprobaciones",
askAiWideA11y: "La IA puede ayudar con los próximos controles",
jumpToIncompleteA11y: "Saltar al siguiente elemento requerido incompleto",
jumpToIncomplete: "Saltar a incompleto",
changeModeA11y: "Cambiar el modo de visualización. Actual: {{mode}}",
viewAsTitle: "Vea esta inspección como",
modeOptionA11y: "{{mode}}: {{desc}}",
viewModeAction: "Ver: {{mode}}",
viewModeTooltip: "Cambiar la forma en que se presenta la lista de verificación",
},
},
overview: {
statusApproved: "Aprobado",
statusCompleted: "Completado",
statusCancelled: "Cancelado",
statusPaused: "Pausada",
statusInProgress: "En curso",
items: "Elementos",
progress: "Progreso",
failures: "Fallos",
urgent: "Urgente",
resumeLabel: "Reanudación: {{text}}",
operationalTimelineA11y_one: "Cronograma operativo, {{count}} evento",
operationalTimelineA11y_other: "Cronograma operativo, {{count}} eventos",
operationalTimelineTitle: "Cronograma operativo · {{count}}",
whoLabel: "Quién: {{actor}}",
whenLabel: "Cuándo: {{when}}",
operationalTimelineA11y_many: "Cronograma operativo, {{count}} eventos",
},
photoEvidence: {
photos: "Fotos",
mediaGuidance: "Hasta 3 fotos por elemento · dibuja para resaltar antes de guardar.",
noPhotosTaken: "No se tomaron fotos",
evidencePhotoA11y: "{{label}} — foto de evidencia {{index}} de {{count}}. Ver tamaño completo",
},
shareSection: {
  statusChanges: "Cambios pedidos",
  statusApproved: "Aprobado",
  statusWaiting: "En espera",
  messageA11y: "Abrir la revisión con {{name}}",
reportSharedWith: "Informe compartido con",
message: "Mensaje",
createJobs: "Crear órdenes de trabajo",
revoke: "Revocar",
revokeAccessA11y: "Revocar el acceso al informe para {{name}}",
revokeConfirmTitle: "¿Revocar el acceso al informe?",
revokeConfirmBody: "{{name}} ya no podrá abrir el enlace del informe. Se conserva el historial de envíos.",
revokeConfirmCancel: "Cancelar",
revokeConfirmConfirm: "Revocar acceso",
revokeFailedTitle: "No se pudo revocar el acceso",
revokeFailedBody: "Vuelva a intentarlo en un momento.",
recipientFallback: "Este destinatario",
},
checklistSection: {
batchHintRange: "Elementos {{from}}–{{to}} de {{total}}",
prefillNotice: "Inspección previa{{dateSuffix}}. Los resultados y notas de la última vez se muestran como referencia. Registre el resultado actual de cada verificación.",
prefillNoticeDateSuffix: " del {{date}}",
emptyGroup: "Nada que completar en este grupo.",
},
evidenceRail: {
collapseA11y: "Contraer {{title}}",
hide: "Ocultar",
},
swipeableWrap: {
ok: "Entendido",
skip: "Saltar",
},
kpis: {
items: "Elementos",
status: "Estado",
cost: "Coste estimado",
reviews: "Revisiones",
percentDone: "{{percent}}% hecho",
statusInProgress: "En curso",
},
summaryCard: {
  suggestedTitle: "Resumen sugerido",
title: "Resumen de inspección",
editSummary: "Editar resumen",
noSummaryYet: "Aún no hay resumen",
generatedAt: "Generado {{date}}",
regenerate: "Regenerar",
generate: "Generar",
generating: "Generando...",
buildingSummary: "Creando el resumen a partir de los datos de la inspección...",
noCredits: "No quedan créditos de uso, así que no se puede redactar el resumen. Compra un paquete de créditos o espera a tus créditos mensuales incluidos.",
noCreditsMember: "No quedan créditos de uso, así que no se puede redactar el resumen. Pide a un administrador del espacio de trabajo que compre créditos o espera a tus créditos mensuales incluidos.",
noCreditsOnDevice: "No quedan créditos de uso, así que no se puede redactar el resumen. Los créditos se compran en AssetWRX en la web o llegan con tus créditos mensuales incluidos.",
topUp: "Comprar créditos",
},
valueAnswer: {
readingLabel: "Lectura",
textLabel: "Respuesta",
textPlaceholder: "Escribe o escanea",
scan: "Escanear",
detected: "Detectado: {{value}}",
detectedOnDevice: "Leído en este dispositivo, sin usar créditos de IA",
use: "Usar",
ignore: "Ignorar",
},
checklistEditor: {
required: "Obligatorio",
yes: "Sí",
no: "No",
ratingReading: "Lectura",
ratingText: "Texto",
meterLabel: "Contador",
meterHintMissing: "Elige qué contador es. Solo así la lectura se añade al historial del contador del activo al completar la inspección.",
meterHintUnit: "Añade la unidad (por ejemplo bar o °C) para que la lectura pueda añadirse al historial del contador del activo.",
meterHintSaved: "Se añade a las lecturas de «{{meter}}» del activo al completar la inspección y cuenta para el mantenimiento por contador.",
meterHours: "Horas",
meterDistance: "Distancia",
meterCycles: "Ciclos",
meterOther: "Otro",
unitLabel: "Unidad",
visionCanAssist: "Vision puede responder con una foto",
useVision: "Escanear esta sección con Vision",
visionOff: "Desactivado",
visionAvailable: "Disponible",
visionRecommended: "Recomendado",
evidenceAlways: "Se espera evidencia fotográfica",
evidenceOnFail: "Se espera evidencia fotográfica si falla",
measureLabel: "Medida",
ratingCondition: "Condición",
ratingLevel: "Nivel",
ratingYesNo: "Sí/No",
ratingPassFailNa: "Aprobado/Fallido/N/A",
ratingPassFlagFail: "Aprobado/Marcado/Fallido",
failWhenLabel: "Falla si",
yesNoFailHint: "Utilice Sí para mensajes sobre problemas presentes (por ejemplo, \"¿Alguna grieta?\"). Utilice No para indicaciones de cumplimiento (por ejemplo, \"¿Está instalada la protección?\").",
captureLabel: "Captura",
images: "Imágenes",
videos: "Vídeos",
groupNameA11y: "Nombre del grupo",
groupNamePlaceholder: "Nombre del grupo",
itemLabelA11yIndexed: "Etiqueta del elemento {{index}}",
itemLabelPlaceholder: "Etiqueta del elemento",
itemDescriptionA11yIndexed: "Descripción del elemento {{index}} (opcional)",
descriptionOptionalPlaceholder: "Descripción (opcional)",
addItemToGroup: "Agregar elemento al grupo",
moveUpA11y: "Subir",
moveDownA11y: "Bajar",
removeGroupA11y: "Quitar grupo",
removeItemA11y: "Quitar elemento",
dragA11y: "Reordenar: mantenga pulsado y arrastre",
itemLabelA11y: "Etiqueta del elemento",
itemLabelPlaceholderExample: "Etiqueta del elemento (por ejemplo, comprobar el aceite del motor)",
itemDescriptionA11y: "Descripción del elemento (opcional)",
requiredNeedsOneItem: "Una lista de verificación necesita al menos un elemento.",
groupDefaultLabel: "Grupo {{number}}",
inspectionNotFoundTitle: "Inspección no encontrada",
couldNotLoadItemsBody: "No se pudo cargar esta inspección para copiar elementos.",
noItemsToCopyTitle: "No hay elementos para copiar",
noItemsToCopyBody: "Esta inspección no tiene elementos de lista de verificación para usar como lista de control.",
couldNotLoadInspectionTitle: "No se pudo cargar la inspección",
tryAgainOrCreateManually: "Inténtalo de nuevo o crea la lista de control manualmente.",
workflowCopySuffix: "{{name}} (copia de flujo de trabajo)",
unsavedTemplateMessage: "Esta lista de control aún no se ha guardado. ¿Salir y perderla?",
    unsavedEditsMessage: "Tienes cambios sin guardar en esta lista. ¿Salir y perderlos?",
    createFailed: "No se pudo crear la lista.",
    updateFailed: "No se pudo actualizar la lista.",
unsavedTemplateEditMessage: "Esta lista de control tiene cambios no guardados. ¿Salir y perderlos?",
templateNameLabel: "Nombre de la lista de control *",
templateNameA11y: "Nombre de la lista de control (obligatorio)",
templateNamePlaceholder: "p.ej. Inspección de automóvil previa a la compra",
generateDraft: "Generar borrador",
templateDetailsTitle: "Detalles y visibilidad de la lista de control",
templateDetailsSummary: "Compatibilidad de activos, descripción, categorías y visibilidad del equipo.",
assetTypeCompatibility: "Compatibilidad de tipos de activos",
assetTypeHint: "Seleccione un tipo de activo al que se aplica esta lista de control. Dejar vacío para cualquier tipo.",
customTypesLabel: "Tus tipos de activo",
customTypesHint: "Elige tipos para usar esta lista solo con ellos. Déjalo vacío para todos los activos de la clase elegida arriba.",
placeTypesLabel: "Tipos de lugar",
placeTypesHint: "Elige tipos de lugar, como Sala, para usar esta lista solo allí. Déjalo vacío para todos los lugares.",
any: "Cualquiera",
visibilityLabel: "Visibilidad",
visibilityAllTeams: "Todos los equipos de la cuenta pueden utilizar esta lista de control.",
visibilityOnlySelectedTeams: "Solo equipos seleccionados (predeterminado: tu equipo actual)",
visibilityCreateTeamHint: "Crea un equipo en Cuenta para restringir la visibilidad",
descriptionHint: "Breve resumen al seleccionar esta lista de control. Opcional.",
descriptionPlaceholderExample: "p.ej. Comprobación del vehículo antes de la compra",
categoriesLabel: "Categorías",
categoriesHint: "Seleccione una o más categorías",
checklistItemsTitle: "Elementos de la lista de verificación",
addGroup: "Agregar grupo",
addItem: "Agregar elemento",
saveChecklist: "Guardar lista de verificación",
templateStructureTitle: "Estructura de lista de control",
evidenceCoverageTitle: "Cobertura de evidencias",
evidenceCoverageCopy_one: "{{count}} elemento captura actualmente al menos un tipo de evidencia.",
evidenceCoverageCopy_other: "{{count}} elementos capturan actualmente al menos un tipo de evidencia.",
versioningTitle: "Control de versiones",
versioningCopy: "Sus cambios se guardan como una versión nueva. Las inspecciones ya iniciadas conservan la lista con la que empezaron.",
newTemplateTitle: "Nueva lista de control",
templateNotFound: "Lista de control no encontrada",
loadingTemplate: "Cargando lista de control…",
startTemplateTitle: "Inicie su lista de control",
startTemplateBody: "Agregue el primer elemento o grupo que debe revisar su inspector. O utilice IA para generar un borrador.",
addFirstItem: "Agrega tu primer elemento",
addAGroup: "Añadir un grupo",
validationTitle: "Validación",
failedToCreateChecklist: "No se pudo crear la lista de verificación.",
failedToUpdateChecklist: "No se pudo actualizar la lista de verificación.",
editTemplateTitle: "Editar lista de control",
saveChanges: "Guardar cambios",
evidenceCoverageCopy_many: "{{count}} elementos capturan actualmente al menos un tipo de evidencia.",
},
checklistDetail: {
loadErrorTitle: "No se pudo cargar esta lista de control",
categoryGeneral: "Generalidades",
versionLabel: "Versión v{{version}}",
updatedDate: "Actualizado {{date}}",
currentVersionIdLabel: "ID de la versión actual:",
versionIdNotSet: "Sin definir",
assetTypesLabel: "Tipos de activo:",
allAssetTypesShort: "Todos",
scopeLabel: "Ámbito:",
versionRowLabel: "Versión:",
versionRowValue: "v{{version}}",
createdRowLabel: "Creada:",
updatedRowLabel: "Actualizada:",
selectedTeamsOnly: "Solo equipos seleccionados",
structureLabel: "Estructura:",
groupsCount_one: "{{count}} grupo",
groupsCount_other: "{{count}} grupos",
itemsCount_one: "{{count}} elemento",
itemsCount_other: "{{count}} elementos",
requiredCountSuffix_one: ", {{count}} obligatorio",
requiredCountSuffix_many: ", {{count}} obligatorios",
requiredCountSuffix_other: ", {{count}} obligatorios",
useTemplateForInspectionA11y: "Usar lista de control para inspección",
itemsCountTitle: "Elementos · {{count}}",
required: "Obligatorio",
ungrouped: "Desagrupado",
groupsCount_many: "{{count}} grupos",
itemsCount_many: "{{count}} elementos",
},
suggestScreen: {
  partialCreatedBody_other: "{{count}} de {{total}} órdenes de trabajo creadas. No se pudo crear «{{title}}». Inténtalo de nuevo.",
  partialCreatedBody_many: "{{count}} de {{total}} órdenes de trabajo creadas. No se pudo crear «{{title}}». Inténtalo de nuevo.",
  partialCreatedBody_one: "{{count}} de {{total}} órdenes de trabajo creada. No se pudo crear «{{title}}». Inténtalo de nuevo.",
  linkFailed_other: "{{count}} órdenes de trabajo creadas, pero no se pudieron añadir a la solicitud. Inténtalo de nuevo.",
  linkFailed_many: "{{count}} órdenes de trabajo creadas, pero no se pudieron añadir a la solicitud. Inténtalo de nuevo.",
  linkFailed_one: "Orden de trabajo creada, pero no se pudo añadir a la solicitud. Inténtalo de nuevo.",
  missingInspectionBody: "Vuelve atrás y abre de nuevo la inspección.",
  partialCreatedTitle: "Algunas órdenes de trabajo no se crearon",
suggestedJobA11y: "Orden de trabajo sugerida {{title}}",
findingsCount_one: "{{count}} hallazgo",
findingsCount_other: "{{count}} hallazgos",
missingTitleOrCategory: "Falta: Título o categoría",
editSuggestedJobTitle: "Editar orden de trabajo sugerida",
titlePlaceholderRepairPipe: "por ej. Reparar tubería con fugas",
scopeOfWorkPlaceholder: "Alcance del trabajo",
whereJobCarriedOutPlaceholder: "¿Dónde se llevará a cabo esta orden de trabajo?",
assignToRecommendedA11y: "Asignar a {{name}}",
suggestedAssigneeLabel: "Sugerido: {{name}} · {{rationale}}",
workPathLabel: "Vía de trabajo",
missingInspection: "Falta inspección",
loadingEllipsis: "Cargando…",
accessRestrictedTitle: "Acceso restringido",
accessRestrictedBody: "Solo el creador de la inspección o un miembro del equipo del activo puede crear órdenes de trabajo a partir de estos elementos fallidos.",
accessDeniedAlertTitle: "Acceso denegado",
accessDeniedAlertBody: "Solo el creador de la inspección o el equipo del activo puede crear estas órdenes de trabajo.",
selectSuggestedJobsTitle: "Seleccionar órdenes de trabajo sugeridas",
selectSuggestedJobsBody: "Seleccione al menos una sugerencia para crear.",
missingDetailsBodySuggest: "A algunas sugerencias seleccionadas les falta título o categoría. Edite esas tarjetas antes de crear órdenes de trabajo.",
jobsAlreadyCreated: "Órdenes de trabajo ya creadas",
noSuggestedJobs: "No hay órdenes de trabajo sugeridas",
allFindingsLinkedBody: "Cada hallazgo fallido o marcado con reparación en esta inspección ya tiene una orden de trabajo vinculada.",
noFailedItemsBody: "Esta inspección actualmente no contiene elementos defectuosos o con marcas de reparación que necesiten una orden de trabajo de seguimiento.",
openReport: "Abrir informe",
linkedJobsTitle: "Órdenes de trabajo vinculadas",
linkedJobsHintCannotRecreate: "Estos hallazgos ya están vinculados a órdenes de trabajo y no se pueden volver a crear a menos que se elimine la orden de trabajo.",
assetFallback: "Activo",
suggestionsCountPill_one: "{{count}} sugerencia",
suggestionsCountPill_many: "{{count}} sugerencias",
suggestionsCountPill_other: "{{count}} sugerencias",
fromFailedItemsPill_one: "de {{count}} elemento fallido",
fromFailedItemsPill_many: "de {{count}} elementos fallidos",
fromFailedItemsPill_other: "de {{count}} elementos fallidos",
alreadyCreatedTitle: "Ya creado",
linkedFindingsHint_one: "{{count}} hallazgo ya tiene órdenes de trabajo vinculadas y no se volverá a sugerir.",
linkedFindingsHint_many: "{{count}} hallazgos ya tienen órdenes de trabajo vinculadas y no se volverán a sugerir.",
linkedFindingsHint_other: "{{count}} hallazgos ya tienen órdenes de trabajo vinculadas y no se volverán a sugerir.",
followUpJobsFromMarkedItems: "Órdenes de trabajo de los elementos fallidos",
aiDraftedHint: "Borrador con IA. Desmarque lo que no deba convertirse en trabajo.",
ruleBasedHint: "Desmarque lo que no deba convertirse en trabajo.",
progressLinkNeedsAttention: "No añadido a la solicitud",
progressLinkMessage: "Se creó la orden de trabajo, pero el progreso del informe/solicitud compartida no se actualizó. {{message}}",
retryLink: "Reintentar",
stillNotLinkedTitle: "Aún no vinculado",
jobCreatedNotLinkedFallback: "Se creó la orden de trabajo pero no se pudo vincular al registro de progreso compartido.",
unableToLinkJobFallback: "No se puede vincular la orden de trabajo a la solicitud.",
missingDetailsBanner_one: "{{count}} sugerencia seleccionada necesita un título o una categoría antes de poder crear órdenes de trabajo. Se recomiendan habilidades, pero son opcionales para las órdenes de trabajo sugeridas.",
missingDetailsBanner_other: "{{count}} sugerencias seleccionadas necesitan un título o una categoría antes de poder crear órdenes de trabajo. Se recomiendan habilidades, pero son opcionales para las órdenes de trabajo sugeridas.",
createJobsA11y_one: "Crear {{count}} orden de trabajo sugerida",
createJobsA11y_many: "Crear {{count}} órdenes de trabajo sugeridas",
createJobsA11y_other: "Crear {{count}} órdenes de trabajo sugeridas",
creatingEllipsisEn: "Creando...",
createJobsButton_one: "Crear {{count}} orden de trabajo",
aiDraft: {
  button: "Redactar con IA",
  again: "Redactar de nuevo con IA",
  notEnough: "Créditos de IA insuficientes",
  failedTitle: "La redacción con IA no funcionó",
  failedBody: "Tu lista no ha cambiado. Inténtalo de nuevo.",
},
createAndAssignButton_one: "Crear y asignar {{count}} orden de trabajo",
createAndAssignButton_other: "Crear y asignar {{count}} órdenes de trabajo",
createAndAssignButton_many: "Crear y asignar {{count}} órdenes de trabajo",
approvedBy: "Aprobado por {{name}}",
handOverIncompleteTitle: "Creadas, no todas entregadas",
handOverIncompleteBody: "Las órdenes existen, pero estas no se entregaron o no se avisó al contratista: {{names}}. Abre cada una para terminar.",
createJobsButton_other: "Crear {{count}} órdenes de trabajo",
findingsCount_many: "{{count}} hallazgos",
missingDetailsBanner_many: "{{count}} sugerencias seleccionadas necesitan un título o una categoría antes de poder crear órdenes de trabajo. Se recomiendan habilidades, pero son opcionales para las órdenes de trabajo sugeridas.",
createJobsButton_many: "Crear {{count}} órdenes de trabajo",
},
shareScreen: {
  askApproveSuggested_other: "Pedir también que apruebe {{count}} reparaciones sugeridas",
  askApproveSuggested_many: "Pedir también que apruebe {{count}} reparaciones sugeridas",
  askApproveSuggested_one: "Pedir también que apruebe {{count}} reparación sugerida",
  askApproveSuggestedHint: "Podrá aprobar o rechazar cada una.",
  relationshipChangeA11y: "Cambiar su relación con el activo",
  relationshipChange: "Cambiar",
  relationship: "Su relación: {{role}}",
  greetingTemplateRepairs: "Hola:\n\nAquí tienes el informe de inspección de {{assetName}}. Abre el enlace para leerlo y pulsa Rechazar en cada reparación propuesta que no quieras. Después firma para dar conformidad, o pulsa Devolver para pedir cambios.\n\nGracias.",
greetingTemplate: "Hola:\n\nAquí tienes el informe de inspección de {{assetName}}. Abre el enlace para leerlo y después firma para dar conformidad, o pulsa Devolver para pedir cambios.\n\nGracias.",
assetFallback: "tu activo",
emailNotSent: "Compartido, pero el correo electrónico no se envió. Copie el enlace para enviarlo usted mismo.",
copyLink: "Copiar enlace",
shareCreatedTitle: "Informe compartido",
shareThisLinkBody: "Comparte este enlace:\n{{link}}",
inspectionNotFound: "Inspección no encontrada.",
contactNeedsEmail: "Añade su correo electrónico para enviar el informe por correo.",
checkEmailAddress: "Revisa el correo electrónico: no parece una dirección válida.",
checkPhoneNumber: "Verifique el número de teléfono: ingrese un número válido para el país seleccionado o déjelo vacío.",
reportResentNotify: "Informe enviado de nuevo. Te avisaremos cuando responda.",
reportSharedNotify: "Informe enviado. Recibirá un correo con un enlace y te avisaremos cuando responda.",
createShareFailedFallback: "No se pudo crear el recurso compartido.",
errorTitle: "Error",
requiredTitle: "Obligatorio",
enterEmailRequired: "Ingrese una dirección de correo electrónico (o seleccione un contacto con un correo electrónico).",
recipientFallback: "Destinatario",
contactFallback: "Contacto",
selectContactTitle: "Seleccione un contacto",
selectContactBody: "Compartir se basa en contactos. Toque \"Seleccionar contacto\" y elija o agregue un contacto para compartir.",
respondByLine: "Responda antes del {{date}}\n\n",
estimatedTotalLine: "Total estimado: {{amount}}\n\n",
reviewLinkLine: "Enlace de revisión: {{link}}",
assetFallbackShort: "Activo",
emailSubject: "Informe de inspección – {{assetName}}",
resentTitle: "Reenviado",
sentTitle: "Enviado",
resentBody: "Informe de inspección reenviado al destinatario.",
sentBody: "Informe de inspección compartido. Se notificará al destinatario.",
deliveryUnconfirmed: "Se creó el recurso compartido pero no se pudo confirmar la entrega. Comparte este enlace manualmente:\n{{link}}",
inspectionNotFoundPlain: "Inspección no encontrada",
onlyCreatorAssigneeOrTeamCanShare: "Solo el creador de esta inspección, su inspector asignado o un miembro del equipo del activo pueden compartir el informe.",
shareLinkNotConfiguredProd: "Aún no se ha configurado un enlace web para compartir para este espacio de trabajo, por lo que es posible que los destinatarios no puedan abrir el enlace del informe. Por favor contacte a su administrador.",
reviewAssistantTitle: "Asistente de revisión",
sending: "Enviando…",
resendReportTo: "Reenviar informe a {{name}}",
sendReportTo: "Enviar informe a {{name}}",
theRequesterFallback: "el solicitante",
oneTapHint: "Rellenado a partir de la solicitud. Cambia la persona o el mensaje abajo si lo necesitas.",
shareTo: "Enviar a",
contactsHint: "Pulsa Seleccionar contacto y elige a la persona. Las personas a las que ya lo enviaste aparecen arriba.",
whoCanOpen: "Solo esa persona puede abrir el informe. El enlace de su correo la conecta directamente. Cualquier otra persona que reciba el enlace solo puede pedirle acceso.",
changeContact: "Cambiar contacto",
selectContact: "Seleccionar contacto",
primaryChooseRole: "Elija un rol",
primaryAddEmail: "Añada un correo electrónico",
primaryResend: "Enviar de nuevo",
primarySend: "Enviar informe",
noEmailOrPhone: "Sin correo electrónico ni teléfono",
shareToContactTitle: "Enviar a",
howToSend: "Cómo enviar",
byEmail: "Por correo electrónico",
roleLabel: "Rol *",
recipientNameOptional: "Su nombre (opcional)",
recipientNamePlaceholder: "por ej. Juan Smith",
recipientEmailLabel: "Su correo *",
recipientEmailA11y: "Su correo (obligatorio)",
recipientEmailPlaceholder: "cliente@ejemplo.com",
phoneOptional: "Teléfono (opcional)",
shareStatus: "Ya enviado",
firstSharedLabel: "Ya enviado el {{date}}",
lastResharedLabel: "Enviado de nuevo el {{date}}",
noResponseByDeadline: "Sin respuesta en la fecha indicada. Pulsa Enviar de nuevo para recordárselo.",
responseDeadlineOptional: "Fecha límite de respuesta (opcional)",
messageOptional: "Mensaje (opcional)",
messagePlaceholder: "Añadir una nota para el destinatario...",
includeSuggestedJobsTitle: "Incluir órdenes de trabajo sugeridas en revisión compartida",
includeSuggestedJobsHint_one: "Añade {{count}} elemento de seguimiento sugerido para la aprobación del destinatario.",
includeSuggestedJobsHint_other: "Añade {{count}} elementos de seguimiento sugeridos para la aprobación del destinatario.",
missingEstimateWarning_one: "{{count}} elemento no tiene estimación de coste; seguirá apareciendo en el informe, pero sin coste. Puede compartirlo ahora o añadir las estimaciones antes.",
missingEstimateWarning_other: "{{count}} elementos no tienen estimación de coste; seguirán apareciendo en el informe, pero sin coste. Puede compartirlo ahora o añadir las estimaciones antes.",
couldNotShareReportTitle: "No se pudo compartir el informe",
sharingFailedFallback: "Error al compartir. Comprueba tu conexión y vuelve a intentarlo.",
includeSuggestedJobsHint_many: "Añade {{count}} elementos de seguimiento sugeridos para la aprobación del destinatario.",
missingEstimateWarning_many: "{{count}} elementos no tienen estimación de coste; seguirán apareciendo en el informe, pero sin coste. Puede compartirlo ahora o añadir las estimaciones antes.",
},
reportScreen: {
  exportFailed: {
    word: "No se pudo crear el archivo de Word. Inténtalo de nuevo.",
    excel: "No se pudo crear el archivo de Excel. Inténtalo de nuevo.",
    pdf: "No se pudo crear el PDF. Inténtalo de nuevo.",
  },
  exportPreparing: {
    word: "Preparando el archivo de Word…",
    excel: "Preparando el archivo de Excel…",
    pdf: "Preparando el PDF…",
  },
editRepairDetailsTitle: "Editar detalles de reparación",
saveFailedFallback: "No se pudo guardar.",
titleLabel: "Título",
titlePlaceholder: "por ej. Reparar grifo que gotea",
categoryLabel: "Categoría",
descriptionLabel: "Descripción",
descriptionPlaceholder: "¿Qué hay que hacer...?",
priorityLabel: "Prioridad",
dueDateOptional: "Fecha de vencimiento (opcional)",
estimatedCostOptional: "Costo estimado (opcional)",
estimatedCostA11y: "Monto del costo estimado",
visibilityLabel: "Visibilidad",
saveRepairFailedTitle: "No se pudo guardar la reparación",
syncFailedGeneric: "Error de sincronización.",
skipped: "Omitido",
downloadPdf: "Descargar PDF",
downloadExcel: "Descargar Excel",
downloadWord: "Descargar Word",
sharePdfToGoogleDrive: "Compartir PDF en Google Drive…",
shareExcelToOneDrive: "Compartir Excel en OneDrive…",
shareWordToSharePoint: "Compartir Word en SharePoint…",
googleDrive: "Google Drive",
oneDrive: "OneDrive",
sharePoint: "SharePoint",
shareRequiredTitle: "Comparta primero el informe",
shareRequiredBody: "Toque Compartir y elija para quién es. Así se crea el enlace que abrirá para leerlo y responder.",
hostedLinkCopiedTitle: "Enlace de revisión copiado",
inspectionReportFileLabel: "Informe de inspección ({{format}})",
exportFileError: "No se pudo generar el archivo de exportación.",
exportReadyTitle: "Exportación lista",
exportReadyBody: "La descarga de su archivo ha comenzado.",
reportInsightTitle: "Información detallada del informe",
reviewRepairEvidenceAction: "Revise la evidencia de reparación y el costo estimado antes de la exportación.",
shareReportAction: "Toque Compartir para enviar un enlace con el que leer el informe y responder.",
runFirstExportAction: "Toque Descargar para guardar una copia en PDF, Excel o Word con su logotipo.",
itemsVisible_one: "{{count}} elemento de inspección es visible en el informe.",
itemsVisible_other: "{{count}} elementos de inspección son visibles en el informe.",
repairFindingsIncluded_one: "Se incluye {{count}} hallazgo de reparación.",
repairFindingsIncluded_other: "Se incluyen {{count}} hallazgos de reparación.",
noRepairFindingsIncluded: "No se incluyen hallazgos de reparación.",
hostedLinkAvailable: "Hay un enlace de revisión listo para enviar.",
hostedLinkNotAvailable: "Aún no hay enlace de revisión. Toque Compartir para crearlo.",
exportRecords_one: "Existe {{count}} registro de exportación reciente.",
exportRecords_other: "Existen {{count}} registros de exportación recientes.",
noExportActivity: "Nadie ha descargado aún este informe.",
metricInspected: "Inspeccionado",
metricRepairs: "Reparaciones",
metricExports: "Exportaciones",
metricSummary: "Resumen",
summaryReady: "Listo",
summaryMissing: "Falta",
insightSourceLabel: "elementos y reparaciones de esta inspección",
nextSteps: "Próximos pasos",
copyHostedReportLink: "Copiar enlace de revisión",
brandingSettings: "Configuración de marca",
moreReportOptionsA11y: "Más opciones de informe",
yourSignOff: "Su aprobación",
signOff: "Aprobar",
reviewAndSignOff: "Aprobar o devolver",
shareA11y: "Compartir",
share: "Compartir",
assignedTo: "Asignado a {{name}}",
unassigned: "Sin asignar",
quoteAwarded: "Presupuesto adjudicado",
quoteRequested: "Presupuesto solicitado",
quotes: "Presupuestos",
jobsCreated_one: "{{count}} orden de trabajo creada",
jobsCreated_other: "{{count}} órdenes de trabajo creadas",
findingsMayNeedJobs_one: "{{count}} hallazgo puede necesitar órdenes de trabajo",
findingsMayNeedJobs_other: "{{count}} hallazgos pueden necesitar órdenes de trabajo",
noRepairFindingsInReport: "No hay hallazgos de reparación en este informe",
createJobsFromFindingsA11y: "Confirmar órdenes de trabajo a partir de los hallazgos",
createJobsFromFindings: "Confirmar órdenes de trabajo",
openLinkedJobsA11y: "Abrir órdenes de trabajo vinculadas",
openLinkedJobs_one: "Abrir orden de trabajo vinculada",
openLinkedJobs_other: "Abrir órdenes de trabajo vinculadas",
approved: "Conforme",
awaitingApproval: "En espera de dar conformidad",
approvedBy: "Conformidad de {{name}}",
recipientFallback: "destinatario",
approvedOnAt: " el {{date}} a las {{time}}",
reviewRequested: "Revisión solicitada",
sharedWithName: "Compartido con {{name}}",
reviewRequestedFallback: "revisión solicitada",
firstShared: "Primera vez compartido {{date}}",
lastReshared: " | Compartido de nuevo el {{date}}",
resendAndUpdateDeadline: "Reenviar y actualizar plazo",
noReviewRequestedYet: "Aún no se ha solicitado ninguna revisión.",
notSharedYetPrefix: "Aún no compartido: utilizar ",
shareAboveLink: "Compartir arriba",
notSharedYetSuffix: " para solicitar una revisión.",
theInspectorFallback: "el inspector",
askInspectorEmptyHint: "Pregunte al inspector sobre este informe. Aún no hay mensajes.",
discussInspectionEmptyHint: "Discuta esta inspección con el revisor. Aún no hay mensajes.",
atAGlance: "De un vistazo",
estTotal: "Total estimado",
approvalLabel: "Conformidad",
approvalAwaiting: "Esperando",
jobsLabel: "Trabajos",
recentExports: "Exportaciones recientes",
loadingExportHistory: "Cargando historial de exportaciones...",
noExportsRecorded: "Aún no se han registrado exportaciones para este informe.",
loadErrorTitle: "No se pudo cargar este informe",
goBack: "Volver",
reportAvailableWhenCompleted: "Informe disponible cuando se completa la inspección.",
findingsAndEvidence: "Hallazgos y evidencia",
noItemsRecorded: "No se registraron elementos de inspección para esta inspección.",
otherGroup: "Otro",
inspectorNotes: "Notas del inspector",
noteLabel: "Nota",
itemSkippedFallback: "Este elemento se omitió durante la inspección.",
mediaCount: "Multimedia · {{count}}",
playVideo: "Reproducir vídeo {{index}}",
repairAndRemediation: "Reparación y remediación",
descriptionOrRecommendation: "Descripción",
recommendation: "Recomendación",
labourAndMaterials: "Mano de obra y materiales",
urgentFallback: "Urgente",
requiredSkills: "Habilidades requeridas",
dueDate: "Fecha de vencimiento",
estimatedCost: "Costo estimado",
urgentRepairNote: "Nota de reparación urgente",
urgentRepairNoteFallback: "Este elemento se ha marcado porque requiere atención urgente.",
jobCreated: "Trabajo creado",
jobsCreatedPlain: "Trabajos creados",
editRepairDetails: "Editar detalles de reparación",
whereThisStands: "En qué punto está",
reportOptionsTitle: "Opciones de informe",
couldNotLoadImageSubtext: "Es posible que la imagen se haya movido o no esté disponible.",
syncReportWorkspaceFailedTitle: "No se pudo crear el archivo",
statusPrefix: "Estado: {{status}}",
templateVersionLabel: "Lista de control: {{name}}{{version}}",
conductedInspection: "Inspección realizada",
inspectorFallback: "Inspector",
itemsVisible_many: "{{count}} elementos de inspección son visibles en el informe.",
repairFindingsIncluded_many: "Se incluyen {{count}} hallazgos de reparación.",
exportRecords_many: "Existen {{count}} registros de exportación recientes.",
jobsCreated_many: "{{count}} órdenes de trabajo creadas",
findingsMayNeedJobs_many: "{{count}} hallazgos pueden necesitar órdenes de trabajo",
openLinkedJobs_many: "Abrir órdenes de trabajo vinculadas",
},
convertScreen: {
  missingShareBody: "Ábrelo desde el informe de inspección para convertir las reparaciones aprobadas en órdenes de trabajo.",
  missingShareTitle: "No hay nada que abrir aquí",
editA11y: "Editar {{title}}",
dueLabel: "Vence el {{date}}",
missingFieldsHint: "Falta: título, categoría o habilidades requeridas",
editJobDetailsTitle: "Editar detalles de la orden de trabajo",
requiredTitle: "Obligatorio",
requiredBody: "Se requieren título y categoría.",
titleLabel: "Título",
titlePlaceholder: "por ej. Reparar grifo que gotea",
categoryLabel: "Categoría *",
priorityLabel: "Prioridad (opcional)",
dueDateLabel: "Fecha de vencimiento (opcional)",
jobLocationLabel: "Ubicación de la orden de trabajo (opcional)",
addressSearchPlaceholder: "Buscar dirección…",
estimateLabel: "Estimación (opcional)",
costPlaceholder: "0.00",
assigneeLabel: "Responsable (opcional)",
noneOption: "Ninguno",
saving: "Guardando…",
save: "Guardar",
missingShare: "Falta el informe compartido",
loading: "Cargando...",
noApprovedRepairsTitle: "No hay reparaciones aprobadas",
noApprovedRepairsBody: "El cliente aún no ha aprobado ninguna reparación de este informe compartido.",
onlyCreatorOrTeamCanConvert: "Solo el creador de la inspección o un miembro del equipo del activo puede crear órdenes de trabajo a partir de este recurso compartido.",
unsavedJobEditsMessage: "Tiene ediciones de órdenes de trabajo no guardadas. ¿Salir y perderlas?",
leave: "Salir",
keepEditing: "Sigue editando",
createJobsErrorTitle: "No se pudieron crear las órdenes de trabajo",
createJobsErrorFallback: "No se pudieron crear órdenes de trabajo.",
selectRepairsTitle: "Seleccionar reparaciones",
selectRepairsBody: "Seleccione al menos una reparación aprobada (marque la casilla en cada tarjeta). Toque una tarjeta para editar el título, la categoría o la persona asignada antes de crearla.",
missingDetailsTitle: "Detalles faltantes",
missingDetailsBody: "A algunas reparaciones seleccionadas les falta título, categoría o habilidades requeridas. Toque cada tarjeta para editarla antes de crear órdenes de trabajo.",
step1WorkPath: "¿Quién hará el trabajo?",
step1WorkPathHint: "Elige tu equipo, un contratista o pide presupuestos. Elegirás a las personas cuando se creen las órdenes de trabajo.",
step2SelectItems: "¿Qué reparaciones necesitan una orden de trabajo?",
creatingJobs: "Creando…",
createJobs_one: "Crear {{count}} orden de trabajo",
createJobs_other: "Crear {{count}} órdenes de trabajo",
createJobs_many: "Crear {{count}} órdenes de trabajo",
},
completeScreen: {
  approvedToast: "Inspección dada por conforme. Comparte el informe o elige Listo.",
  alerts: {
    optionalBody_other: "{{count}} elementos opcionales no están respondidos ni omitidos. ¿Completar de todos modos?",
    optionalBody_many: "{{count}} elementos opcionales no están respondidos ni omitidos. ¿Completar de todos modos?",
    optionalBody_one: "{{count}} elemento opcional no está respondido ni omitido. ¿Completar de todos modos?",
    failedTitle_other: "{{count}} elementos fallidos no tienen foto ni nota",
    failedTitle_many: "{{count}} elementos fallidos no tienen foto ni nota",
    failedTitle_one: "{{count}} elemento fallido no tiene foto ni nota",
    requiredBody_other: "Responde u omite {{count}} elementos obligatorios antes de completar esta inspección.",
    requiredBody_many: "Responde u omite {{count}} elementos obligatorios antes de completar esta inspección.",
    requiredBody_one: "Responde u omite {{count}} elemento obligatorio antes de completar esta inspección.",
    completedToast: "Inspección completada",
    optionalTitle: "Elementos sin responder",
    goToFailed: "Ir al elemento fallido",
    failedBody: "Añade una foto o una nota para que otros vean el problema, o complétala tal cual.",
    jumpToFirst: "Ir al primero",
    requiredTitle: "Elementos obligatorios sin hacer",
    tryAgain: "Reintentar",
    savingBody: "Se conservan en este dispositivo. Toca Reintentar y después completa la inspección.",
    savingTitle: "Algunas respuestas aún no se han guardado",
    conflictChoose: "Elegir",
    conflictBody: "Elige Conservar mis respuestas o Usar las suyas y después complétala.",
    conflictTitle: "Otra persona cambió esta inspección",
  },
  status: {
    nextVisit: "Próxima visita prevista el {{date}}.",
    requesterWaiting: "El solicitante está esperando este informe.",
    sentTo: "Enviada a {{name}} para su aprobación.",
    approveSelf: "Revisa los hallazgos y toca Dar conformidad.",
    approveOrLeave: "Da tú la conformidad o déjala para {{name}}.",
  },
  actions: {
    approve: "Dar conformidad",
    createCertificate: "Emitir el certificado renovado",
    shareRequester: "Compartir el informe con el solicitante",
    createApprovedJobs: "Crear las órdenes de trabajo aprobadas",
    scheduleNext: "Programar la próxima inspección",
    shareReport: "Compartir informe",
    exportReport: "Exportar informe",
    report: "Informe",
    done: "Listo",
    confirmJobs: "Confirmar órdenes de trabajo",
  },
loadErrorTitle: "No se pudo cargar esta inspección",
loadErrorDescription: "Comprueba tu conexión y vuelve a intentarlo.",
notFoundTitle: "Inspección no encontrada",
notFoundDescription: "Es posible que esta inspección se haya eliminado o que el enlace no esté actualizado.",
goBack: "Volver",
notCompletedYet: "Esta inspección aún no está terminada.",
back: "Atrás",
generateSummaryError: "No se pudo generar el resumen de inspección. Por favor inténtalo de nuevo.",
saveSummaryError: "No se pudo guardar el resumen de la inspección. Por favor inténtalo de nuevo.",
reopenErrorTitle: "No se pudo volver a abrir",
reopenErrorFallback: "Inténtelo de nuevo.",
jobFollowUpTitle: "Seguimiento de {{name}}",
jobFollowUpDescription: "Seguimiento de la inspección {{checklist}} de {{assetName}}, {{date}}.",
assetFallback: "activo",
templateFallback: "Inspección",
certificateTitle: "Certificado {{name}}",
cannotCreateCertificateTitle: "No se puede crear el certificado",
cannotCreateCertificateBody: "Esta inspección no está vinculada a un activo.",
certificateCreatedTitle: "Certificado creado",
certificateCreatedBody: "Certificado guardado en los Documentos del activo.",
errorTitle: "No se pudo crear el certificado",
certificateCreateError: "No se pudo crear el certificado.",
inspectedLabel: "Inspeccionado",
failedItemsLabel: "Elementos fallidos",
followUpJobsLabel: "Órdenes de trabajo sugeridas",
inspectionAssistantTitle: "Asistente de inspección",
confirmNextActions: "Qué sigue",
moreCompletionActions: "Más",
moreCompletionActionsSummary: "Crear una orden de trabajo a mano, reabrir la inspección o compartir el informe.",
createJobNow: "Crear orden de trabajo ahora",
notifyTeam: "Notificar al equipo",
syncFailedTitle: "No se pudo guardar el resumen",
syncFailedFallback: "La solicitud falló. Comprueba tu conexión y vuelve a intentarlo.",
},
templateCard: {
allAssetTypes: "Todos los tipos de activo",
categoryGeneral: "Generalidades",
categoriesCount_one: "{{count}} categoría",
categoriesCount_many: "{{count}} categorías",
categoriesCount_other: "{{count}} categorías",
usedCount_zero: "Aún no se ha usado",
usedCount_one: "Usado {{count}} vez",
usedCount_many: "Usado {{count}} de veces",
usedCount_other: "Usado {{count}} veces",
createdDate: "Creado {{date}}",
allTeams: "Todos los equipos",
selectedTeams: "Equipos seleccionados",
},
checklistCard: {
allTypes: "Todos los tipos",
shared: "Compartida",
totalItems: "Sugerencias sobre",
required: "Obligatorio",
optional: "Opcional",
usedTimes_one: "Usado {{count}} vez",
usedTimes_other: "Usado {{count}} veces",
completedCount_one: "{{count}} completado",
completedCount_many: "{{count}} completados",
completedCount_other: "{{count}} completados",
estMinutes: "~{{count}} mín.",
createdDate: "Creado {{date}}",
usedTimes_many: "Usado {{count}} veces",
},
conditionalEditor: {
showOnlyWhen: "Mostrar solo cuando",
addPreviousItemFirst: "Agregue primero un elemento anterior para que esto sea condicional.",
parentItem: "Elemento principal",
untitledItem: "Elemento sin título",
alwaysShown: "Siempre mostrado",
expectedAnswer: "Respuesta esperada",
notConditional: "No condicional",
clearCondition: "Quitar condición",
onlyShownWhen: "Solo se muestra cuando \"{{parent}}\" es {{value}}.",
conditionInvalidAfterReorder: "La condición actual ya no es válida después de cambiar el orden. Elija un elemento anterior o bórrela.",
itemAlwaysShown: "Este elemento siempre se muestra.",
},
card: {
awaitingReviewerResponse: "Esperando respuesta del revisor",
inspectorFallback: "Inspector",
recipientFallback: "Destinatario",
sharePendingCount_one: "{{count}} pendiente",
sharePendingCount_many: "{{count}} pendientes",
sharePendingCount_other: "{{count}} pendientes",
shareDeclinedCount_one: "{{count}} rechazado",
shareDeclinedCount_many: "{{count}} rechazados",
shareDeclinedCount_other: "{{count}} rechazados",
shareApprovedCount_one: "{{count}} aprobado",
shareApprovedCount_many: "{{count}} aprobados",
shareApprovedCount_other: "{{count}} aprobados",
sharedWith: "Compartido con {{names}}",
responseDue: "Respuesta antes de {{date}}",
templateFallback: "Inspección",
assetFallback: "Activo desconocido",
inspectorA11y: "Inspector {{name}}",
issuesCountA11y_one: "{{count}} problema",
issuesCountA11y_many: "{{count}} problemas",
issuesCountA11y_other: "{{count}} problemas",
repairsCountA11y_one: "{{count}} reparación",
repairsCountA11y_many: "{{count}} reparaciones",
repairsCountA11y_other: "{{count}} reparaciones",
urgentCountA11y_one: "{{count}} urgente",
urgentCountA11y_many: "{{count}} urgentes",
urgentCountA11y_other: "{{count}} urgentes",
openAssetA11y: "Abrir activo {{assetName}}",
urgentPill: "Urgente {{count}}",
issuesPill: "Problemas {{count}}",
repairsPill: "Reparaciones {{count}}",
awaitingApproval: "En espera de aprobación",
sharedDense: "Compartida",
reportShared: "Informe compartido",
},
noteSuggestions: {
suggestions: "Sugerencias",
tapToInsert: "Toque para insertar",
findingRecentNotes: "Buscando notas recientes...",
},
/** The runner's item controls, footer and summary line (were English literals). */
runner: {
  skipGroupBody_other: "¿Marcar {{count}} elementos de este grupo como omitidos y pasar al siguiente grupo?",
  skipGroupBody_many: "¿Marcar {{count}} elementos de este grupo como omitidos y pasar al siguiente grupo?",
  skipGroupBody_one: "¿Marcar {{count}} elemento de este grupo como omitido y pasar al siguiente grupo?",
  syncUnsavedBanner: "Un cambio no se guardó. Toca para reintentar.",
  syncFailedBanner: "Algunas respuestas aún no se han guardado. Se conservan en este dispositivo. Toca para reintentar.",
  tryAgain: "Inténtalo de nuevo.",
  moveToItemTitle: "No se pudo ir a ese elemento",
  captureUnsupported: "Este tipo de captura no se puede guardar en un elemento.",
  captureScanBody: "Los códigos QR los lee el escáner; no se guardan en los elementos.",
  captureScanTitle: "Usa el escáner para los códigos QR",
  captureMeasurementAdded: "Medición añadida a la nota del elemento.",
  captureMeasurement: "Medición: {{value}}",
  captureNoteAdded: "Nota añadida al elemento.",
  capturePhotoAdded: "Foto añadida al elemento.",
  captureNoNote: "No se capturó ninguna nota.",
  captureNoPhoto: "No se hizo ninguna foto.",
  capturePhotosOff: "Este elemento no admite fotos.",
  captureNoItem: "Abre primero un elemento y vuelve a capturar.",
  captureMismatch: "Esta captura es de otra inspección.",
  captureNotFound: "No se encontró esa captura. Vuelve a capturarla.",
  captureNotSavedTitle: "Captura no guardada",
  skipGroupReason: "Grupo no aplicable",
  skipGroupConfirm: "Omitir grupo",
  skipGroupTitle: "¿Omitir este grupo?",
  keysClose: "Cerrar este panel",
  keysToggle: "Mostrar u ocultar este panel",
  keysSkip: "Omitir el elemento abierto",
  keysYesNo: "Responder Sí / No (elemento abierto)",
  keysRate: "Responder Aprobado / Fallido / No aplica (elemento abierto)",
  keysPrevNext: "Elemento o grupo anterior / siguiente",
  timelineStatusScheduled: "Programada",
  timelineStatusCreated: "Creada",
  timelineAutomatic: "Automático",
  timelineUpdated: "Última actualización",
  timelineCancelled: "Inspección cancelada",
  timelineApproved: "Informe aprobado",
  timelineCompleted: "Inspección completada",
  timelineResumeScheduled: "Reanudación programada",
  timelinePaused: "Inspección en pausa",
  timelineStarted: "Inspección iniciada",
  timelineCreated: "Inspección creada",
  exportReport: "Exportar informe",
  report: "Informe",
  askAiDescription: "Obtén ayuda con las siguientes comprobaciones según tus respuestas.",
  askAiTooltip: "La IA puede ayudarte con las siguientes comprobaciones",
  askAi: "Preguntar a la IA",
  saveAndExit: "Guardar y salir",
  savedFindInWork: "Guardado. Encuéntrala en Trabajo, en Mío, para continuar.",
  delete: "Eliminar",
  deleteBody: "No se puede deshacer.",
  deleteTitle: "¿Eliminar esta inspección?",
  allItemsDone: "Todos los elementos listos. Toca Completar inspección.",
  sharedReportHint: "Si alguien te ha compartido un informe, abre el enlace de su correo. También puedes ver en Actividad los informes que te esperan.",
  requester: "Solicitante",
  fromRequest: "Desde una solicitud",
  unknownStatus: "Desconocido",
  itemsHidden: "{{total}} elementos ya no se aplican y se han ocultado.",
  itemHiddenOne: "«{{label}}» ya no se aplica, así que se ha ocultado.",
  addNoteFirstBody: "Escribe una nota breve y toca Pulir.",
  addNoteFirstTitle: "Añade primero una nota",
  signInVideos: "Inicia sesión para añadir vídeos.",
  signInPhotos: "Inicia sesión para añadir fotos.",
  signInTitle: "Inicia sesión",
  recordVideo: "Grabar o elegir un vídeo",
  takePhoto: "Hacer o elegir una foto",
  polishFailedTitle: "No se pudo pulir el texto",
  polishedTitle: "Texto pulido",
  discard: "Descartar",
  editDraft: "Editar",
  accept: "Aceptar",
  revert: "Deshacer",
  draftNoteTitle: "Borrador de nota para {{label}}",
  previousInspection: "Inspección anterior",
  previousRating: "Anterior: {{rating}}",
  previousNote: "La última vez: {{note}}",
  videoOfA11y: "Vídeo {{index}} de {{total}}",
  photoOfA11y: "Foto {{index}} de {{total}}",
  expandDetails: "Mostrar detalles",
  collapseDetails: "Ocultar detalles",
  collapsed: "plegado",
  expanded: "desplegado",
  stateNotCompletedShort: "sin completar",
  stateSkippedShort: "omitido",
  stateCompletedShort: "completado",
  itemHeaderA11y: "{{label}}, {{state}}, {{expanded}}",
  stateNotCompleted: "Sin completar",
  stateCompleted: "Elemento completado",
  stateSkipped: "Omitido",
  followUpAddA11y: "Añadir un seguimiento para {{label}}",
  followUpEditA11y: "Editar el seguimiento de {{label}}",
  flaggedNeedsJob: "Marcado. ¿Necesita una orden de trabajo?",
  mediaAddA11y: "Añadir una foto o un vídeo para {{label}}",
  mediaAttachedA11y: "Añadir pruebas para {{label}}, {{total}} adjuntas",
  noteAddA11y: "Añadir o dictar una nota para {{label}}",
  noteEditA11y: "Editar la nota de {{label}}",
  note: "Nota",
  naA11y: "No aplicable",
  naSub: "No se aplica aquí",
  na: "No aplica",
  flagSub: "Necesita otra revisión",
  flag: "Marcar",
  failSub: "No cumple los criterios",
  fail: "Fallido",
  passSub: "Cumple los criterios de inspección",
  pass: "Aprobado",
media: "Multimedia",
followUp: "Seguimiento",
followUpProposed: "Orden de trabajo propuesta",
yesOrNo: "Sí o No",
passFailNa: "Aprobado, Fallido o N/A",
passFlagFail: "Aprobado, Marcar o Fallido",
level: "Nivel",
conditionRating: "Calificación del estado",
stop: "Detener",
finishing: "Finalizando...",
dictate: "Dictar",
polishing: "Puliendo…",
generating: "Generando…",
polish: "Pulir",
generateDraft: "Generar borrador",
previous: "Anterior",
completeInspection: "Completar inspección",
nextItem: "Siguiente elemento",
lastItem: "Último elemento",
nextGroup: "Siguiente grupo",
lastGroup: "Último grupo",
nextUnanswered: "Siguiente sin responder",
started: "Iniciada {{when}}",
startedBy: "Iniciada {{when}} · {{name}}",
},
viewModel: {
completionHintBlocking: "«Completar inspección» aparecerá cuando se respondan u omitan los elementos obligatorios.",
completionHintFinalGroup: "«Completar inspección» aparecerá cuando llegues al grupo final.",
completionHintLastItem: "«Completar inspección» aparecerá en el último elemento.",
completionHintOptionalRemain: "Los elementos de la lista de verificación opcionales permanecen; puede finalizar una vez que haya terminado con los elementos requeridos.",
},
pendingMedia: {
failedCaption_one: "{{count}} no subido: toque para reintentar",
failedCaption_many: "{{count}} no subidos: toque para reintentar",
failedCaption_other: "{{count}} no subidos: toque para reintentar",
pendingCaption_one: "{{count}} guardado en este dispositivo, esperando para subirse",
pendingCaption_many: "{{count}} guardados en este dispositivo, esperando para subirse",
pendingCaption_other: "{{count}} guardados en este dispositivo, esperando para subirse",
retryA11y: "Reintentar subir esta captura",
pendingA11y: "Captura guardada en este dispositivo, pendiente de subir",
},
sideProgressPanel: {
sections: "Secciones",
noSections: "Sin secciones",
general: "Generalidades",
},
findingsReview: {
  notAnswered_other: "{{count}} sin responder",
  notAnswered_many: "{{count}} sin responder",
  notAnswered_one: "{{count}} sin responder",
  failedNeedJob_other: "{{count}} elementos fallidos necesitan una orden de trabajo",
  failedNeedJob_many: "{{count}} elementos fallidos necesitan una orden de trabajo",
  failedNeedJob_one: "{{count}} elemento fallido necesita una orden de trabajo",
reportArchived: "Informe guardado",
findingsNeedDecision_one: "{{count}} elemento fallido necesita una orden de trabajo, o un motivo para dejarlo.",
findingsNeedDecision_other: "{{count}} elementos fallidos necesitan una orden de trabajo, o un motivo para dejarlos.",
noFindingsNeedFollowUp: "Ningún hallazgo necesita seguimiento.",
recommendedWorkPackages_one: "{{count}} orden de trabajo sugerida a partir de los hallazgos.",
recommendedWorkPackages_other: "{{count}} órdenes de trabajo sugeridas a partir de los hallazgos.",
allClear: "Todos los elementos inspeccionados están correctos.",
successfulItemsTitle: "Elementos correctos · {{count}}",
successfulItemsSummary: "Elementos que pasaron sin ninguna acción",
notRated: "Sin clasificar",
answerItem: "Reabrir para responder",
planWork: "Confirmar orden de trabajo",
decisionA11y: "{{label}}: {{itemLabel}}",
uncertain: "Sin responder",
urgentFinding: "Hallazgo urgente",
failedFinding: "Elemento fallido",
findingsNeedDecision_many: "{{count}} elementos fallidos necesitan una orden de trabajo, o un motivo para dejarlos.",
recommendedWorkPackages_many: "{{count}} órdenes de trabajo sugeridas a partir de los hallazgos.",
},
vision: {
findingsGroup: "Hallazgos adicionales",
keepWorking: "Seguir trabajando",
scan: {
group: "Escanear",
item: "Escanear",
groupHint: "Vision puede ayudar con {{count}} de {{total}} comprobaciones",
recommendedHint: "Recomendado: escanea primero esta sección",
resultsReady: "Resultados listos",
analysing: "Analizando…",
open: "Abrir escaneo",
removeFinding: "Quitar hallazgo",
supportedByEvidence: "Respaldado por evidencia visual",
cameraAssisted: "Con ayuda de la cámara, sin foto guardada",
},
walk: {
  cardActionUpload: "Añadir fotos",
  cardTitleUpload: "Revisar la sala con fotos",
cardTitle: "Recorrer con la cámara",
cardBody: "Vision puede responder {{count}} de {{total}} comprobaciones con lo que ve y las completa. Solo revisa lo que no pudo ver o de lo que no estaba seguro.",
cardAction: "Empezar recorrido",
howTo: "Toca el botón rojo y camina despacio, deteniéndote un momento en cada elemento de la lista.",
walking: "Escaneando… camina despacio y detente en cada elemento. Toca Finalizar cuando hayas dado la vuelta.",
start: "Empezar recorrido",
stop: "Pausar recorrido",
uploadTitle: "Añade fotos de toda la sala",
autoFilled: "Completadas automáticamente: {{count}}",
rushedTitle: "Ha sido muy rápido",
rushedBody: "Has recorrido {{total}} elementos en {{taken}} s. Detente unos 2 segundos en cada uno (unos {{suggested}} s en total) para que Vision vea todo con nitidez.",
keepScanning: "Seguir escaneando",
finishAnyway: "Finalizar igualmente",
slowDown: "Ve más despacio y sujeta el teléfono firme",
},
capture: {
title: "Escanear",
uploadTitle: "Añadir fotos para escanear",
manual: "Responder manualmente",
moveSlowly: "Toma algunas fotos nítidas de lo que comprueba esta sección.",
damageTip: "Acércate y fotografía a lo largo del panel con un ángulo bajo: las abolladuras se ven en los reflejos.",
checklistToggle: "Qué capturar · {{done}}/{{total}}",
checklistToggleNoCount: "Qué capturar",
found: "encontrado",
removeFrameA11y: "Quitar foto {{index}}",
lowLight: "Se necesita más luz",
limitReached: "Límite de fotos alcanzado. Quita una para añadir otra.",
costHint_one: "El análisis usa {{count}} crédito · {{balance}} disponibles",
costHint_other: "El análisis usa {{count}} créditos · {{balance}} disponibles",
costHint_many: "El análisis usa {{count}} créditos · {{balance}} disponibles",
shutterA11y: "Tomar foto",
finishCount: "Terminar escaneo ({{count}})",
cameraBlocked: "El acceso a la cámara está desactivado. Actívalo en Ajustes o añade fotos.",
cameraNeeded: "Permite el acceso a la cámara para escanear o añade fotos.",
openSettings: "Abrir ajustes",
grant: "Permitir cámara",
webNoLocal: "Aquí AssetWRX revisa las fotos en la nube. Revisas todo antes de que se guarde.",
upload: "Subir fotos",
useCamera: "Usar cámara",
fromPhotos: "Añadir desde fotos",
failed: "No se pudo añadir la foto. Inténtalo de nuevo.",
seedFailed: "No se pudo abrir la foto. Haz una nueva o añade una desde tus fotos.",
},
stage: {
reading_labels: "Leyendo etiquetas…",
checking_items: "Comprobando los puntos de inspección…",
reviewing_condition: "Revisando el estado visible…",
preparing_results: "Preparando resultados…",
},
coverage: {
observed: "Observado",
partial: "Visto en parte",
not_observed: "No observado",
},
cloud: {
offline: "Estás sin conexión, así que solo se muestran los resultados del dispositivo.",
switched_off: "El análisis en la nube está desactivado para este espacio de trabajo. Solo se muestra lo que el dispositivo pudo detectar.",
nothing_to_scan: "Nada de esta sección puede leerse en una foto. Responda las comprobaciones usted mismo.",
no_credits: "No hay suficientes créditos de IA para el análisis en la nube. Solo se muestra lo que el dispositivo pudo detectar.",
timeout: "El análisis en la nube tardó demasiado. Solo se muestra lo que el dispositivo pudo detectar.",
blocked_content: "Estas fotos no se pudieron analizar en la nube. Solo se muestra lo que el dispositivo pudo detectar.",
failed: "El análisis en la nube no se completó. Solo se muestra lo que el dispositivo pudo detectar.",
analyseNow: "Analizar con IA ahora · {{cost}}",
retry: "Reintentar el análisis en la nube",
},
review: {
title: "Revisar sugerencias",
emptyTitle: "No se pudieron determinar estas comprobaciones con el escaneo",
emptyBody: "Vuelve a escanear con el elemento bien visible o responde tú mismo.",
summaryReady: "Listas: {{count}}",
summaryCheck: "Por revisar: {{count}}",
summaryNotSeen: "No vistas: {{count}}",
summaryIssues: "Posibles problemas: {{count}}",
frameA11y: "Foto del escaneo {{index}}",
readyTitle: "Listo para confirmar",
checkTitle: "Revisa estas",
notObservedTitle: "No observado",
issuesTitle: "Problemas adicionales",
coverageTitle: "Qué cubrió el escaneo",
acceptReady: "Aceptar respuestas listas ({{count}})",
bulkSaved: "Respuestas guardadas: {{count}}",
undo: "Deshacer",
done: "Hecho",
scanAgain: "Escanear de nuevo",
completeManually: "Responder manualmente",
leaveTitle: "¿Salir sin revisar?",
leaveBody: "Algunas sugerencias de este escaneo no se han revisado. Si sales ahora, se descartarán.",
keepReviewing: "Seguir revisando",
discard: "Descartar",
observed: "Observado",
suggested: "Sugerido",
differs: "Difiere de tu respuesta. Aceptar la sustituye.",
partial: "Solo visible en parte. Revísalo antes de aceptar.",
conflict: "Las lecturas no coinciden. Elige el valor correcto.",
previousReading: "Último registro: {{value}}",
backwards: "Inferior a la última lectura registrada.",
unitMismatch: "Este contador se registra en {{unit}}.",
serialMismatch: "No coincide con el número de serie registrado de este activo.",
accept: "Aceptar",
change: "Cambiar",
reject: "Rechazar",
save: "Guardar",
possibleIssue: "Posible problema",
confirmIssue: "Confirmar problema",
flagIssue: "Marcar para revisión",
noIssue: "Sin problema",
decision: {
accepted: "Guardado",
changed: "Guardado con tu cambio",
rejected: "No utilizado",
fail: "Añadido a Hallazgos adicionales",
flag: "Marcado en Hallazgos adicionales",
dismissed: "Descartado",
},
reason: {
not_observed: "No se ve en las fotos.",
partial: "Solo visible en parte.",
low_confidence: "No es lo bastante claro para sugerir una respuesta.",
no_evidence: "Nada del escaneo responde a esto.",
},
},
defect: {
corrosion: "Corrosión",
leak: "Fuga",
crack: "Grieta",
wear: "Desgaste",
deformation: "Deformación",
missing_component: "Componente ausente",
loose_component: "Componente suelto",
damage: "Daño",
contamination: "Contaminación",
damp_staining: "Manchas de humedad",
mould_growth: "Crecimiento similar a moho",
blockage: "Obstrucción",
overheating: "Sobrecalentamiento",
dent: "Abolladura",
scratch: "Arañazo",
paint_damage: "Daño en la pintura",
glazing_damage: "Daño en el cristal",
light_damage: "Daño en la luz",
tyre_damage: "Daño en el neumático",
cable_damage: "Daño en el cable",
exposed_wiring: "Cableado expuesto",
misalignment: "Desalineación",
blocked_access: "Acceso bloqueado",
other_visible_anomaly: "Algo que conviene revisar",
},
trainingShare: {
title: "Datos para mejorar Vision",
body: "Vision guarda qué sugerencias aceptó, cambió o rechazó su equipo, sin fotos, para medir su precisión. Esta opción está activada de forma predeterminada: las fotos de evidencia guardadas para esas sugerencias también se usan para entrenar a Vision. Se copian a Google Cloud en la UE para el entrenamiento y se eliminan allí en un plazo de 30 días. Al desactivarla se detiene cualquier uso posterior; un modelo ya entrenado con ellas no se revierte. Los registros se conservan 24 meses.",
toggle: "Usar nuestras fotos de evidencia para mejorar Vision",
on: "Activado. Las fotos de evidencia de las sugerencias revisadas pueden copiarse a Google Cloud (UE) para entrenar a Vision.",
off: "Desactivado. Solo se guardan las decisiones de revisión, sin fotos.",
failed: "No se pudo cambiar este ajuste. Inténtelo de nuevo.",
retry: "Reintentar",
},
},
ratingScale: {
poor: "Deficiente",
fair: "Regular",
good: "Bueno",
veryGood: "Muy bueno",
excellent: "Excelente",
low: "Bajo",
quarter: "Un cuarto",
half: "Medio",
threeQuarter: "Tres cuartos",
full: "Lleno",
},
};
